<div class="modal-header">
  <h5 class="modal-title">Authorised Signatory</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div class="mb-3 row">
    <label class="col-sm-3 col-form-label">User:</label>
    <div class="col-sm-9">
      <select class="form-select" 
              [(ngModel)]="selectedUserId" 
              (change)="validate()">
        <option [ngValue]="null"></option>
        <option *ngFor="let user of users" [ngValue]="user.id">
          {{user.firstName}} {{user.lastName}}
        </option>
      </select>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button *ngIf="!loading" 
          type="button" 
          class="btn btn-success" 
          (click)="updateAuthorisedSignatory()" 
          [disabled]="updateDisabled">
    Update
  </button>
  <button *ngIf="loading" 
          type="button" 
          class="btn btn-success" 
          disabled>
    <span class="spinner-border spinner-border-sm me-2"></span>
    Updating...
  </button>
</div>